import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import Box from "../../../components/Box";
import { KTCard } from "../../../_metronic/helpers/components/KTCard";
import { KTCardBody } from "../../../_metronic/helpers/components/KTCardBody";
import Content from "../../../_metronic/layout/components/content/Content";
import { ToolbarWrapper } from "../../../_metronic/layout/components/toolbar";
import { PageTitle } from "../../../_metronic/layout/core";
import { useNavigate, useSearchParams } from "react-router-dom";
import { Helpers } from "../../../helpers/Helpers";
import toast from "react-hot-toast";
import { storeActivityIndicator } from "../../../redux/reducers/authSlice";
import { AddConstantResponse } from "../../../models/response/constant/AddConstantResponse";
import { ConstantService } from "../../../services/ConstantService";
import { RootState } from "../../../redux/store";
import CustomSingleSelect, { CustomSingleSelectModel } from "../../../components/CustomSingleSelect";
import { GetConstantListResponse } from "../../../models/response/constant/GetConstantListResponse";
import { CountyService } from "../../../services/CountyService";
import { GetCountyByIdResponse } from "../../../models/response/county/GetCountyByIdResponse";
import { CountryService } from "../../../services/CountryService";

const CountyAdd = () => {
    const auth = useSelector((state: RootState) => state.auth)
    const navigate = useNavigate();
    const pageName = "Genel Tanımlamalar > Şehir Tanımları"
    const [searchParams, setSearchParams] = useSearchParams();
    const dispatch = useDispatch();
    const [countyId, setCountyId] = useState<string | undefined>(undefined);
    const [shortName, setShortName] = useState('');
    const [longName, setLongName] = useState('');
    const [selectedCountry, setSelectedCountry] = useState<CustomSingleSelectModel | undefined>(undefined);
    const [stateCode, setStateCode] = useState('');
    const [selectedRegion, setSelectedRegion] = useState<CustomSingleSelectModel | undefined>(undefined);

    useEffect(() => {
        var id = searchParams.get("id");
        getData(id);
    }, [])

    const getData = async (_id: string | undefined | null = undefined) => {
        try {
            dispatch(storeActivityIndicator(true))

            var id = _id ? _id : searchParams.get("id") ? searchParams.get("id") : undefined;

            if (id) {
                var response: GetCountyByIdResponse = await CountyService.getCountyById(id);

                if (!response.isSuccess) {
                    toast.error(response.message)
                    return;
                }

                setCountyId(response.data.countyId);
                setShortName(response.data.code);
                setLongName(response.data.name);

                if (response.data.countryId)
                    setSelectedCountry({ label: response.data.countryName, value: response.data.countryId });

                setStateCode(response.data.stateCode);

                if (response.data.regionId)
                    setSelectedRegion({ label: response.data.regionName, value: response.data.regionId });
            }
        } catch (error: any) {
            toast.error(error)
        }
        finally {
            dispatch(storeActivityIndicator(false))
        }
    }

    const saveCounty = async () => {
        try {
            if (Helpers.isEmpty(shortName))
                toast.error('Kodu alanını doldurunuz!')
            else if (Helpers.isEmpty(longName))
                toast.error('Adı alanını doldurunuz!')
            else if (!selectedCountry)
                toast.error('Ülkesi alanını doldurunuz!')
            else {
                dispatch(storeActivityIndicator(true));

                var response: AddConstantResponse = await ConstantService.addConstant(countyId, 'COUNTY', longName, selectedCountry.value, shortName, stateCode, selectedRegion?.value);

                if (!response.isSuccess) {
                    toast.error(response.message)
                    return;
                }

                toast.success(response.message)

                dispatch(storeActivityIndicator(false));
                navigate(Helpers.getGoBackUrl())
            }
        } catch (error: any) {
            toast.error(error);
            dispatch(storeActivityIndicator(false));
        }
    }

    return (
        <React.Fragment>
            <ToolbarWrapper filters={undefined} />

            <PageTitle breadcrumbs={[{
                title: pageName.split('>').slice(0, pageName.split('>').length - 1).join(' > ') + ' > ',
                isActive: false,
                path: ''
            }]}>{(pageName.split('>')[pageName.split('>').length - 1])}</PageTitle>

            <Box className="mb-10">
                <Content>
                    <KTCard className="ebbe-card">
                        <KTCardBody>
                            <h4 className="mb-10 text-black">Genel Bilgiler</h4>

                            <div className='row'>
                                <div className="col-md-4">
                                    <div>
                                        <label htmlFor="exampleFormControlInput1" className="form-label required">Kodu</label>
                                        <input style={{ border: '1px solid #F1F1F4' }} value={shortName} onChange={(e) => setShortName(e.target.value)} type="text" className="form-control form-control-solid" />
                                    </div>

                                    <div className="mt-5">
                                        <label htmlFor="exampleFormControlInput1" className="form-label">Eyalet Kodu</label>
                                        <input style={{ border: '1px solid #F1F1F4' }} value={stateCode} onChange={(e) => setStateCode(e.target.value)} type="text" className="form-control form-control-solid" />
                                    </div>
                                </div>
                                <div className="col-md-4">
                                    <div>
                                        <label htmlFor="exampleFormControlInput1" className="form-label required">Adı</label>
                                        <input style={{ border: '1px solid #F1F1F4' }} value={longName} onChange={(e) => setLongName(e.target.value)} type="text" className="form-control form-control-solid" />
                                    </div>

                                    <div className="mt-5">
                                        <label htmlFor="exampleFormControlInput1" className="form-label">Bölgesi</label>
                                        <CustomSingleSelect
                                            selectedValue={selectedRegion}
                                            onChange={setSelectedRegion}
                                            insertable={{
                                                onSubmit: { code: 'COUNTY_REGION' }
                                            }}
                                            onMenuOpen={() => ConstantService.getConstantList('COUNTY_REGION')}
                                            labelName='value'
                                            valueName='constantId'
                                        />
                                    </div>
                                </div>
                                <div className="col-md-4">
                                    <div>
                                        <label htmlFor="exampleFormControlInput1" className="form-label required">Ülkesi</label>
                                        <CustomSingleSelect
                                            selectedValue={selectedCountry}
                                            onChange={setSelectedCountry}
                                            onMenuOpen={() => CountryService.getCountryList()}
                                            labelName='name'
                                            valueName='countryId'
                                        />
                                    </div>
                                </div>
                            </div>
                        </KTCardBody>
                    </KTCard>

                    <KTCard className="ebbe-card mt-10">
                        <KTCardBody>
                            <Box flexDirection="row" justifyContent="flex-end">
                                <Box mr="15px">

                                    <button className="btn btn-sm btn-light btn-active-light-primary" onClick={() => navigate(Helpers.getGoBackUrl())}>Geri</button>
                                </Box>
                                <Box>
                                    <button className="btn btn-primary btn-sm" onClick={saveCounty}>Kaydet</button>
                                </Box>
                            </Box>
                        </KTCardBody>
                    </KTCard>
                </Content>
            </Box>
        </React.Fragment>
    )
}

export default CountyAdd;